import React from 'react';
import BannerSlider from './BannerSlider';
import FavouriteTool from './FavouriteTool';
import { Link } from 'react-router-dom';
import ProductSlider from './ProductSlider';
import OurProductSlider from './OurProductSlider';
import BlogGridSlider from './BlogGridSlider';
import TestimonailSlider from './TestimonailSlider';
import PartnerSlider from './PartnerSlider';


function Home() {
  return (
    <>
    <BannerSlider/>
    {/* <!-- Banner End -->
   <!-- Discount Banner Start --> */}
    <section className="section-padding">
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-6">
                    <div className="discount_box shine-effect" style={{ backgroundImage: 'url(/tm/react/toolways/assets/images/discount_banner/34.png)' }}>
                        <div className="discount_text">
                            <h6 className="mb-0 subtitle">Discount 50%</h6>
                            <h4 className="title mb-2 text-light">Handy Machine Tools</h4>
                            <p className="mb-3 text-light">Lorem ipsum dolor sit amet, consectetur.</p>
                            <Link to="/shop" className="thm-btn btn-rounded thm-bg-color-one">Shop Now</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="discount_box shine-effect color_change" style={{ backgroundImage: 'url(/tm/react/toolways/assets/images/discount_banner/35.jpg)' }}>
                        <div className="discount_text">
                            <h6 className="mb-0 subtitle">Discount 30%</h6>
                            <h4 className="title mb-2 text-light">Cutter Power Tools</h4>
                            <p className="mb-3 text-light">Lorem ipsum dolor sit amet, consectetur.</p>
                            <Link to="/shop" className="thm-btn btn-rounded thm-bg-color-one">Shop Now</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Discount Banner End -->
    <!-- Fruits Start --> */}
    <FavouriteTool/>
    {/* <!-- Fruits End -->
    <!-- Vegetables Start --> */}
    <ProductSlider/>
    {/* <!-- Vegetables End -->
     <!-- Newsletter Start --> */}
    <section className="section section-bg relative newsletter_bg" style={{ backgroundImage: 'url(/tm/react/toolways/assets/images/constructionletter2.jpg)' }}>
        <div className="testimonial-overlayer"></div>
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-5">
                    <div className="newsletter_text">
                        <h2 className="title">
                            SPECIAL UP TO 15% OFF ALL Products.
                        </h2>
                        <p>Lorem ipsum dolor sit amet, consectetur.</p>
                        <form action="#" method="POST">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fal fa-envelope"></i>
                                    </span>
                                </div>
                                <input type="email" className="form-control" placeholder="Email Address" autoComplete="off" required/>
                                <div className="input-group-append">
                                    <button className="thm-btn thm-bg-color-one" type="submit">Subscribe</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Newsletter End -->
    <!-- Drinks Start --> */}
    <OurProductSlider/>
    {/* <!-- Drinks End -->
    <!-- Section Start --> */}
    <BlogGridSlider/>
    {/* <!-- Section End -->
    <!-- Discount Banner Start --> */}
    <section className="section-padding">
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12 d-flex justify-content-center">
                    <div className="banner-image">
                        <figure className="shine-effect">
                            <Link to="#">
                                <img src="/tm/react/toolways/assets/images/1.jpg" alt='img'/>
                            </Link>
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Discount Banner End -->
    <!-- Testimonial Banner Start --> */}
    <TestimonailSlider/>
    {/* <!-- Testimonial Banner End -->
    <!--Partner Start--> */}
    <PartnerSlider/>
    </>
  )
}

export default Home